ImageMetaData
	Vector2 position
	DateTime dateTime
	
Image
	static js async ImageMetaData getMetaData: dynamic file
		                                       int inputTimezone = 0
		                                       int outputTimezone = 0
		return new ImageMetaData(Vector2.none, "")
		return new Promise((resolve, reject) => {
			EXIF.getData(file, function() {
	        	var meta = EXIF.getAllTags(this)
				System.print(JSON.stringify(meta))
				System.print("meta.DateTime: "+meta.DateTime)
				resolve(new ImageMetaData(
					meta.GPSLatitude ? new Vector2(
						$Image.convertDmsToDecimal(meta.GPSLongitude, meta.GPSLongitudeRef),
						$Image.convertDmsToDecimal(meta.GPSLatitude, meta.GPSLatitudeRef),
						"geo"
					) : Vector2.none,
					$Image.parseTimeString(meta.DateTime, inputTimezone, outputTimezone)
				))
			})
		})
		
	// Convert time string in the format "2019:07:28 13:37:16" to DateTime
	static private DateTime parseTimeString: string str, int inputTimezone, int outputTimezone
		if not str or str.length < 19: return null
		let parts = str.split " "
		let date = parts[0].split ":"
		let time = parts[1].split ":"
		return DateTime.fromValues(
			year:   cast date[0]
			month:  cast date[1]
			day:    cast date[2]
			hour:   cast time[0]
			minute: cast time[1]
			second: cast time[2]
			inputTimezone
			outputTimezone
		)
		
	// Convert longitude or latitude in the format [11, 25, 10], "E" to decimal 
	static private convertDmsToDecimal: int[] dms, string ref
		let decimal = dms[0] + dms[1]/60 + dms[2]/3600
		if ref == "S" or ref == "W": decimal = -decimal
		return decimal
		
	
